var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoAction = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.885 4a7.885 7.885 0 1 0 0 15.77 7.885 7.885 0 0 0 0-15.77zm0 1a6.885 6.885 0 1 1 0 13.77 6.885 6.885 0 0 1 0-13.77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.27 10.153c.574 0 1.048.435 1.108.993l.007.122v4.308a.5.5 0 0 1-.992.09l-.008-.09v-4.308a.115.115 0 0 0-.08-.11l-.036-.005h-1.23a.5.5 0 0 1-.09-.992l.09-.008h1.23zm-.308-3.077.1.006a.808.808 0 1 1-.202 0l.102-.006z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.73 15.077a.5.5 0 0 1 .09.992l-.09.008h-3.692a.5.5 0 0 1-.09-.992l.09-.008h3.693z"
})))));
export { SvgInfoAction as ReactComponent };
export default __webpack_public_path__ + "assets/images/info-action.svg";